import '../../sass/dashboard.scss'
import BigSection from "./big-section";
import TopTrending from "./top-trending";
import PersonalInfo from "./personal-info";

function Dashboard() {
  return (
    <div className={'dashboard'}>
      <BigSection />
      <TopTrending />
      {/*<PersonalInfo />*/}
    </div>
  )
}

export default Dashboard;
